var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXmarkCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.721 16.359a.963.963 0 0 1-1.36 1.36l-1.359-1.36-1.36 1.36a.961.961 0 0 1-1.359-1.36L13.642 15l-1.359-1.359a.961.961 0 0 1 1.359-1.36l1.36 1.36 1.359-1.36a.963.963 0 0 1 1.36 1.36L16.361 15zM15 7a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
})));
export default SvgXmarkCircle;